import type { AnyZodObject } from "zod";

import { z } from "zod";

export const PaginationParams = z.object({
	pageIndex: z.number().optional(),
	pageSize: z.number().optional()
});

export const SortParams = z.object({
	sortBy: z.string().regex(/^.+\.(asc|desc)$/).optional()
});

export function Filters<T extends AnyZodObject>(schema: T) {
	return PaginationParams.merge(SortParams).merge(schema).transform(schema => (
		{
			...schema,
			pageIndex: schema.pageIndex ?? 0,
			pageSize: schema.pageSize ?? 10
		}
	));
}

export type T_SortParams = z.infer<typeof SortParams>;
export type T_PaginationParams = z.infer<typeof PaginationParams>;
export type T_Filters<T extends Record<string, any> | z.ZodObject<any>> = T extends z.ZodObject<any>
	? z.infer<T> & T_PaginationParams & T_SortParams
	: T & T_PaginationParams & T_SortParams;
